import { Component, TemplateRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ExportarService } from 'src/app/modules/projeto-completo/services/exportar.service';
import { environment } from 'src/environments/environment';
import { NavigationService } from '../../services/navigation.service';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-exportar-list',
  templateUrl: './exportar-list.component.html',
  styleUrls: ['./exportar-list.component.scss']
})
export class ExportarListComponent extends BaseListComponent<any> {
  
  loader: boolean = false;
  modalLogin: boolean = true;
  modalRef?: BsModalRef;

  entidade: number;
  tipo: number;
  model: {};
  link: { link: string, linkMonolinha: string, contentType: string, authorization: string };
  form = this.fb.group({
    usuario: ['', [Validators.required, Validators.maxLength(11)]],
    senha: ['', [Validators.required]],
  });

  get usuario() { return this.form.get('usuario'); }
  get senha() { return this.form.get('senha'); }

  exportTypes: any[];
  // TODO: sugestão ao mesclar a branch do exportar dashboard e do exportar agenda positiva, passar os filenames para o backend e usar a mesma numeração que retorna no this.myService.index()
  exportListFilenames: string[] = [
    "projeto_compleot_1.csv",
    "003_Query_(Produtos).csv",
    "004_Query_(Metas).csv",
    "002_Query_(Entregas).csv",
    "001_Query_(Projetos).csv",
    "005_Query_(Indicadores).csv",
    "100_Query_(Panorama).csv",
    "008_Query_(PontoCriticoRisco).csv",
    "009_Query_(AtividadesIndicadores).csv",
    "010_Query_(AcompanhamentoOrcamentarioProjeto).csv",
    "011_Query_(AcompanhamentoOrcamentarioIndicador).csv",
    "012_Query_(AcompanhamentoOrcamentarioEntrega).csv",
    "013_Query_(DemandasMonitoramento).csv",
    "014_Query_(IRFES).csv",
    "015_Query_(IRFES-Aditivo).csv",
    "016_Query_(IRFES-PROA).csv",
    "017_Query_(IRFES-INDICADOR).csv",
    "017_Query_(IRFES-ENTREGAS).csv",
    "019_Query_(IRCPS).csv",
    "020_Query_(IRCPS-PROAS).csv",
    "021_Query_Projeto_PROA.csv",
    "022_Query_(AgendaPositiva).csv",
    "045_Query_(IRCPS-PortalCP).csv",
    "046_Query_(Projeto-Cronograma).csv",
    "047_Query_(Execucao-Orcamentaria-Distribuicao).csv",
  ];

  constructor(
    private myService: ExportarService,
    private modalService: BsModalService,
    private fb: FormBuilder,
    private navigation: NavigationService,
    private authService: AuthService
  ) {
    super()
  }

  async ngOnInit() {
    this.loader = true;
    
    this.entidade = await this.authService.getSession();
    this.myService.index().subscribe((res: []) => {
      this.exportTypes = res;
      this.loaded();
      this.loader = false;
    });
  }

  login(): void {
    this.loader = true;
    if (!this.form.valid) {
      return;
    }
    this.model = this.form.value;
    this.myService.login(this.model).subscribe({
      next: (retorno) => {
        this.link = {
          link: '',
          linkMonolinha: '',
          contentType: 'text/csv',
          authorization: retorno.authorization
        }

        if (([10, 11, 12, 20, 47, 48]).includes(this.tipo)) {
          this.link.link = environment.apiUrl + '/exportar/' + this.tipo + '?';
          this.link.linkMonolinha = environment.apiUrl + '/exportar/' + this.tipo + '?multi=0';
        }else if(this.tipo == 4){
          this.link.link = environment.serverUrl + '/rest/api/exportar/' + this.tipo;
          this.link.linkMonolinha = environment.serverUrl + '/rest/api/exportar/' + this.tipo + '?multi=0';
        }
         else if(([21,46,50]).includes(this.tipo)){
          this.link.link = environment.serverUrl + '/rest/api/exportar/' + this.tipo+ '?execution=5';
          this.link.contentType = 'application/json';
          this.link.linkMonolinha = environment.apiUrl + '/exportar/' + this.tipo + '?multi=0&execution=5';
        } else {
          this.link.link = environment.serverUrl + '/projeto-completo/exportar-csv/' + this.tipo;
          this.link.linkMonolinha = environment.serverUrl + '/projeto-completo/exportar-csv/' + this.tipo + '?multi=0';
        }

        this.modalLogin = false;
        this.loader = false;
      },
      error: (error) => {
        this.msgError(error.error);
        this.modalLogin = true;
        this.loader = false;
      }
    });
  }

  downloadFile(tipo: number): void {
    this.loading();
    this.myService.downloadFile(tipo).subscribe({
      next: (response) => {
        const blob = new Blob([response.body], { type: 'application/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const item = this.exportTypes.find(element => element.download == tipo);
        // TODO: sugestão ao mesclar a branch do exportar dashboard e do exportar agenda positiva, passar os filenames para o backend e usar a mesma numeração que retorna no this.myService.index()
        if (tipo == 45) {
          if (item && item.hasOwnProperty('filename')) { // Nome do arquivo a ser baixado
            a.download = item.filename;
          } else {
            a.download = '045_Query_(IRCPS-PortalCP).csv';
          }
        }
        else if(tipo == 46){
          a.download = "046_Query_(Projeto-Cronograma).csv";
        } 
        else if(tipo == 50){
          a.download = "050_Query_Projeto_SEI.csv";
        }
        else {
          if(item && item.hasOwnProperty('filename')){
            a.download = item.filename;
          }
          else{
            a.download = this.exportListFilenames[tipo - 1]; // Nome do arquivo a ser baixado
          }
        }
        a.click();
        this.loaded();
      },
      error: (error) => {
        this.msgError(error.error.message);
        this.modalLogin = true;
        this.loaded();
      }
    });
  }

  gerarLink(tipo: number, template: TemplateRef<any>): void {
    this.modalLogin = true;
    this.tipo = tipo;
    this.modalRef = this.modalService.show(template);
  }

}
